/**
 * Single source of truth for backend endpoints.
 *
 * Everything here is derived from the Vite env vars written by the
 * Supabase / Lovable Cloud connection. Nothing in the app should hardcode a
 * project ref or a *.supabase.co URL — that way, pointing the app at a
 * different backend is a config change, not a code change.
 */

export const SUPABASE_URL: string =
  import.meta.env.VITE_SUPABASE_URL ?? "";

export const SUPABASE_ANON_KEY: string =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? "";

export const SUPABASE_PROJECT_ID: string =
  import.meta.env.VITE_SUPABASE_PROJECT_ID ??
  // Derive from the URL when the explicit var is absent.
  (SUPABASE_URL.match(/https?:\/\/([^.]+)\./)?.[1] ?? "");

/** Base URL for edge functions, e.g. `${FUNCTIONS_URL}/get-stripe-config`. */
export const FUNCTIONS_URL = `${SUPABASE_URL}/functions/v1`;

/** localStorage key the Supabase JS client uses for the session. */
export const AUTH_STORAGE_KEY = `sb-${SUPABASE_PROJECT_ID}-auth-token`;
